import { TutorForSelfBookingFields } from '~/types/cart'

export function isTutoringForSelfCartValid(cart: TutorForSelfBookingFields): boolean {
  return (
    typeof cart.language === 'string' &&
    typeof cart.location === 'string' &&
    typeof cart.product?.id === 'number' &&
    cart.language &&
    cart.location &&
    cart.product.id > 0 &&
    cart.levelsOfEducation.length > 0 &&
    cart.subjects.length > 0
  )
}

export function isFormValidForOrderTutoringCustomization(form: TutorForSelfBookingFields): boolean {
  return (
    typeof form.language === 'string' &&
    typeof form.location === 'string' &&
    form.language &&
    form.location &&
    form.levelsOfEducation.length > 0 &&
    form.subjects.length > 0
  )
}

export function isFormValidForUpdatingLocation(form: TutorForSelfBookingFields): boolean {
  return typeof form.location === 'string' && Boolean(form.location)
}

export function isFormValidForStudentPreferenceCustomization(form: TutorForSelfBookingFields): boolean {
  return (
    typeof form.language === 'string' && form.language && form.levelsOfEducation.length > 0 && form.subjects.length > 0
  )
}
